import React, { useState } from 'react';
import { PUBLIC_IMG_URL } from '../../../../lib/endpoints';
import { NEWS_REFERENCES_LOGOS } from '/src/lib/constants/logoConstants';

const PER_PAGE = 6;

export default function TrustedBy() {
    const [page, setPage] = useState(0);
    const totalPages = Math.ceil(NEWS_REFERENCES_LOGOS.length / PER_PAGE);
    const visible = NEWS_REFERENCES_LOGOS.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE);

    return (
        <section className="lp-references">
            <p className="lp-references__title">
                Trusted by leading investors &amp; institutions across emerging markets
            </p>
            <div className="lp-references__carousel">
                <button
                    className="lp-references__arrow lp-references__arrow--prev"
                    onClick={() => setPage(p => Math.max(0, p - 1))}
                    disabled={page === 0}
                    aria-label="Previous"
                >
                    &#8249;
                </button>

                <div className="lp-references__logos">
                    {visible.map((ref, i) => (
                        <div
                            key={page * PER_PAGE + i}
                            className="lp-references__logo"
                            title={ref.name}
                            style={{
                                backgroundImage: `url("${PUBLIC_IMG_URL}${ref.logo}"), url("${PUBLIC_IMG_URL}${ref.fallbackLogo}")`
                            }}
                        />
                    ))}
                </div>

                <button
                    className="lp-references__arrow lp-references__arrow--next"
                    onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))}
                    disabled={page === totalPages - 1}
                    aria-label="Next"
                >
                    &#8250;
                </button>
            </div>
        </section>
    );
}
